export function CrossPlatformIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="8" y="12" width="12" height="12" rx="2" />
      <rect x="28" y="12" width="12" height="12" rx="2" />
      <rect x="18" y="26" width="12" height="12" rx="2" />
      <line x1="14" y1="24" x2="24" y2="26" />
      <line x1="34" y1="24" x2="24" y2="26" />
    </svg>
  );
}
